import {getUserProfileData} from "../../services/actions/user";

export const formattingSubscription = (sub) => {
    const subVal = sub.map((el) => {
        if (el.subscription === "Ideas All") {
            return [el, {subscription: "Ideas World"}, {subscription: "Ideas Россия"}]
        } else if (el.subscription === "Unity All") {
            return [el, {subscription: "Unity World"}, {subscription: "Unity Россия"}]
        } else if (el.subscription === "Premium") {
            return [el, {subscription: "Unity World"}, {subscription: "Unity Россия"}, {subscription: "Unity All"}]
        } else {
            return el
        }
    })

    const flatSubVal = subVal.flat();

    const uniqueSubscriptions = flatSubVal.filter((item, index, self) => {
        return index === self.findIndex((el) => el.subscription === item.subscription);
    });

    return uniqueSubscriptions
}

export const refreshSubsRequest = () => {
    getUserProfileData().then(async (res) => {
        const data = await res.json()
        if (!data.hasOwnProperty('error')) {
            const subs = JSON.stringify(formattingSubscription(data.subscription))
            localStorage.setItem("subscription", subs)
        }
    })
}